import React from 'react';
import styled from 'styled-components'
import colors from '../../globals/colors'
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { lang, translateContent } from '../../globals/Translations';
import { IsHorizontalMobile, IsMobile, IsTablet, useWindowSize } from '../../globals/UIHooks';
import Project from '../../shared/Project'
import { getProjectStatusUILabel } from '../../shared/ProjectStatus';
import { NiceIntrestRate, NiceNumberWithCurrency } from '../../shared/UIFormatting';
import ProjectStatusBox from './ProjectStatusBox';
import { CorrectIcon, FalseIcon } from '../../assets/icon/Icons';
export const ProjectCards = styled.a<{}>`  
    box-shadow: 0 16px 32px rgb(0 0 0 / 10%);
    background-color: ${colors.lightest};
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.25s ease-in-out 0s;
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
    color: ${colors.darkest};
    :hover {
        box-shadow: rgb(0 0 0 / 30%) 0px 16px 32px;
        transform: translate3d(0px, -4px, 0px);
        transition: all 0.25s ease-in-out 0s;
    }
`
export const ProjectButton = styled.div<{}>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    color: ${colors.dark};
    :hover {
        background-color: ${colors.primaryOpacity};
        color: ${colors.primary};
    }
`

export const Row = (name: string, value: string | JSX.Element, key: number) => {
    const odd = key % 2 === 0
    return (
        <div style={{
            display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between',
            backgroundColor: odd ? colors.darkOpacity : colors.primaryOpacity
        }}>
            <div style={{ padding: 6, fontWeight: 400 }}>{name}</div>
            <div style={{ padding: 6, textAlign: 'right' }}>{value}</div>
        </div>
    )
}

export const CheckUncheckRow = (name: string, value: boolean, key: number) => {
    const odd = key % 2 === 0
    return (
        <div style={{
            display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between',
            backgroundColor: odd ? colors.darkOpacity : colors.primaryOpacity
        }}>
            <div style={{ padding: 6, fontWeight: 400 }}>{name}</div>
            <div style={{ padding: 6, textAlign: 'right' }}>{value ? <CorrectIcon /> : <FalseIcon />}</div>
        </div>
    )
}


const ProjectImage = styled.div<{ url: string }>`
    height: 250px;
    max-width: 100%;
    background-size: cover;
    background-position: center;
    background-image: url(${({ url }) => url});
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
`

const defaultPadding = 32

export const GetDurationString = (project?: Project) => {
    const minMonth = project && project.finance.durationMin || 0
    const maxMonth = project && project.finance.durationMax || 0
    return minMonth + '-' + maxMonth + ' ' + lang(TranslatedTerms.MONTHS)
}

const ProjectCard: React.FC<{ project?: Project }> = ({ project }) => {

    const { width } = useWindowSize()

    if (!project) return <></>

    const imageHeight = IsMobile(width) ? 280 : IsHorizontalMobile(width) ? 380 : IsTablet(width) ? 260 : (width || 1000) / 5
    return (
        <ProjectCards href={"/projects/" + project.projectId}>
            <div>
                <ProjectImage url={project.images[0]} style={{ height: imageHeight }}>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: defaultPadding / 2 }}>
                        <ProjectStatusBox status={getProjectStatusUILabel(project)} />
                    </div>
                </ProjectImage>
                <div style={{ padding: defaultPadding }}>
                    <h4>{translateContent(project.projectTitle)}</h4>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {Row(lang(TranslatedTerms.FUNDING_TARGET), NiceNumberWithCurrency(project.finance.targetFunding), 0)}
                        {Row(lang(TranslatedTerms.INTEREST_RATE_PR_Y), NiceIntrestRate(project.finance.interestRate, true), 1)}
                        {Row(lang(TranslatedTerms.DURATION), GetDurationString(project), 2)}
                        {Row(lang(TranslatedTerms.COVER), NiceIntrestRate(project.finance.coveragePercentage, true), 3)}
                    </div>
                </div>
            </div>
            <ProjectButton>
                <span>{lang(TranslatedTerms.SEE_PROJECT)}</span>
            </ProjectButton>
        </ProjectCards>

    );
};

export default ProjectCard;